import type { SidebarMenuItem, SidebarMenuSection } from "components/partials/sidebar-menu";
import { SidebarMenu } from "components/partials/sidebar-menu";
import { useFeatureFlags } from "contexts/feature-flag-context";
import {
  CLIENT_USER_MENU_ITEMS,
  getActiveClientUserMenuItemId,
} from "./app-sidebar.constants";

type ClientUserSidebarContentProps = {
  pathname: string;
};

export const ClientUserSidebarContent = ({ pathname }: ClientUserSidebarContentProps) => {
  const featureFlags = useFeatureFlags();

  const sections: SidebarMenuSection[] = [
    {
      id: "client-user-navigation",
      items: CLIENT_USER_MENU_ITEMS.filter((item) => {
        if (item.featureFlag && !featureFlags[item.featureFlag]) {
          return false;
        }
        return true;
      }).map(function mapItem({ children, ...item }): SidebarMenuItem {
        return {
          ...item,
          children: children
            ?.filter((child) => {
              if (child.featureFlag && !featureFlags[child.featureFlag]) {
                return false;
              }
              return true;
            })
            .map(mapItem),
        };
      }),
    },
  ];
  const activeItemId = getActiveClientUserMenuItemId(pathname);

  return <SidebarMenu.Items sections={sections} activeItemId={activeItemId} />;
};
